import React from 'react'

import type { SessionFeaturedProjects } from '@mc/api'
import { TileImage } from '@mc/design-system'

import Image from 'components/LegacyImage'
import classes from './Gallery.module.scss'

type GalleryProps = {
  projects?: SessionFeaturedProjects[]
  className?: string
}

export const Gallery = ({ projects, className, ...rest }: GalleryProps) => (
  <div className={`row justify-content-center ${className || ''}`} {...rest}>
    {projects &&
      projects.map(
        (project) =>
          project.imageUrl && (
            <div
              key={project.id}
              className={`${classes.width} d-flex flex-column col-md-4 col-sm-6 col-xs-12`}
            >
              <TileImage
                className='mc-corners--sm'
                image={
                  <Image
                    src={project.imageUrl}
                    alt={project.imageUrlAltText ?? ''}
                    height={336}
                    width={336}
                    objectFit='cover'
                  />
                }
              />
              <p className='mc-text-large text-align-left mc-mt-2'>
                {project.description}
              </p>
            </div>
          ),
      )}
  </div>
)
